export default __webpack_public_path__ + "static/media/numbers.90b52d6b.svg";